export const mapCoreUserToUser = (user: CoreUser): User => {
  return {
    id: user.profileId ? parseInt(user.profileId) : null,
    account: user.account || '',
    email: user.email || '',
    fullName: `${user.firstName} ${user.lastName}`,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    profileDescription: user.profileDescription || '',
    regDate: user.registerDate,
    handicap: user.hcp,
    gender: user.gender,
    dateOfBirth: user.birthday,
    temporary: user.isTemporary,
    country: generateUserCountry(user),
    club: generateUserClub(user),
    isHcpSyncEnabled: user.isHcpSyncEnabled,
    isPrivate: user.isPrivate,
    units: user.units,
    avatarUrl: user.avatarUrl,
    coverImgUrl: user.coverImgUrl,
    privileges: user.privileges,
    userNote: user.userNote,
  }
}

export const mapUpdatedCoreUserToUser = (user: CoreUser): User => {
  return {
    id: user.profileId ? parseInt(user.profileId) : null,
    account: user.account || '',
    email: user.email || '',
    fullName: `${user.firstName} ${user.lastName}`,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    profileDescription: user.profileDescription || '',
    regDate: user.registerDate,
    handicap: user.hcp,
    gender: user.gender,
    dateOfBirth: user.birthday,
    temporary: user.isTemporary,
    country: generateUserCountry(user),
    club: generateUserClub(user),
    isPrivate: user.isPrivate,
    units: user.units,
    userNote: user.userNote,
  }
}

const generateUserCountry = (user: CoreUser): UserCountry | null => {
  if (user.countryId) {
    return {
      id: user.countryId,
      name: user.country,
      countryCode: user.countryCode,
    }
  }
  return null
}

const generateUserClub = (user: CoreUser): UserClub | null => {
  if (user.homeClubId) {
    return {
      id: user.homeClubId,
      name: user.homeClub,
      country: {
        id: user.homeClubCountryId,
        name: user.homeClubCountry,
      },
    }
  }
  return null
}
